module.exports = __webpack_public_path__ + "img/14.5b2a3e29.jpeg";